import { IMPORT_EXPORT_PREFIX } from '@constants';
import dayjs from 'dayjs';

export const getExportFileName = () => {
  const now = dayjs();

  return `${IMPORT_EXPORT_PREFIX}_${now.year()}_${now.month() + 1}_${now.date()}_${now.hour()}_${now.minute()}`;
};
